var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"column":"","justify-center":"","align-center":""}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":_vm.size,"width":_vm.width,"color":"primary"}}),_c('br'),_c('p',[_vm._v("Caricamento...")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }